import React from "react";
import { Redirect, Route } from "react-router-dom";
import isFunction from "lodash/isFunction";
import PropTypes from "prop-types";

import Restricted from "utils/Restricted";

const ProtectedRoute = ({ component: Component, condition, requiredPermissions, ...rest }) => (
  <Restricted requiredPermissions={requiredPermissions} redirect>
    <Route
      {...rest}
      render={(props) =>
        (isFunction(condition) ? condition() : condition) ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  </Restricted>
);

ProtectedRoute.propTypes = {
  condition: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  requiredPermissions: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

ProtectedRoute.defaultProps = {
  condition: true,
  requiredPermissions: [],
};

export default ProtectedRoute;
